module.exports = __webpack_public_path__ + "img/Pulsemonitor_ausgeschnitten.d7fb5581.png";